/**
 * ReportsTab — tab "Reportes" del panel Data Health.
 *
 * v1: re-wrappea el panel existente `DataIssuesPanel` sin redesign. La decisión
 * #5 aprobada por el usuario es: cosmético only. No tocar la lógica interna
 * del DataIssuesPanel; solo asegurar coherencia visual con el contenedor padre.
 *
 * v2: redesign más profundo si surge necesidad (issues estilo Inspector, etc.).
 */
import React from 'react';
import DataIssuesPanel from '../DataIssuesPanel';

interface Props {
  clientId: string;
  clientName?: string;
}

const ReportsTab: React.FC<Props> = ({ clientId, clientName }) => {
  return (
    <div>
      <DataIssuesPanel clientId={clientId} clientName={clientName} />
    </div>
  );
};

export default ReportsTab;
